module.exports = {
	"stepway": {
		"version": "2.0.0"
	},
	"dragdropway": {
		"version": "2.0.0"
	},
	"formviewer": {
		"version": "2.0.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/easyFormConfig.json
// module id = 13
// module chunks = 0